import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { makeStyles, InputBase, InputAdornment, IconButton } from '@material-ui/core';
import CancelIcon from '@material-ui/icons/Cancel';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(() => ({
  inputRoot: {
    width: '100%',
    height: ' 100%',
    paddingRight: 2,
  },
  input: {
    fontSize: 14,
    fontWeight: 400,
  },
  iconPadding: {
    width: '1em',
    height: '1em',
    padding: 0,
    fontSize: 14,
  },
  icon: {
    width: '1rem',
    height: '1rem',
    padding: 0,
    fontSize: 14,
  },
}));

const TextFilter = ({
                      filterValue,
                      dataKey,
                      columnData: { isFilterable, startAdornment },
                      onChange,
                    }) => {
  const classes = useStyles();
  const { en: { tables } } = useSelector((state) => state.i18n);
  const textInput = useRef(null);

  useEffect(() => {
    if (filterValue === '') {
      textInput.current.value = '';
    } else if (textInput.current.value === '' && filterValue !== null) {
      textInput.current.value = filterValue;
    }
  }, [filterValue]);

  const handleInputChange = (e) => {
    if (onChange) {
      onChange(dataKey, e.target.value, true);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleInputChange(e);
    }
  };

  return (
    <InputBase
      inputRef={textInput}
      defaultValue={filterValue}
      onChange={handleInputChange}
      classes={{
        root: classes.inputRoot,
        input: classes.input,
      }}
      placeholder={isFilterable ? tables.filter : ''}
      onKeyDown={handleKeyDown}
      disabled={!isFilterable}
      autoComplete='off'
      startAdornment={
        startAdornment
          ? <InputAdornment position='start'>
            {startAdornment}
          </InputAdornment>
          : null
      }
      endAdornment={textInput?.current?.value ? (
        <IconButton
          className={classes.iconPadding}
          onClick={() => onChange(dataKey, '')}
        >
          <CancelIcon className={classes.icon} />
        </IconButton>
      ) : null}
    />
  );
};

TextFilter.propTypes = {
  filterValue: PropTypes.string,
  dataKey: PropTypes.string.isRequired,
  columnData: PropTypes.shape({
    isFilterable: PropTypes.bool,
  }).isRequired,
  onChange: PropTypes.func,
};

TextFilter.defaultProps = {
  filterValue: '',
  onChange: undefined,
};

export default TextFilter;
